import { render, staticRenderFns } from "./NewsEventDetail.vue?vue&type=template&id=81450452&"
import script from "./NewsEventDetail.vue?vue&type=script&lang=js&"
export * from "./NewsEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports